module.exports = __webpack_public_path__ + "media/day/356-930f4304.svg";